// Gallery photos (thumbs 800×800, full 1600px). `caption` is the short tile label;
// `alt` is the unique, clinically descriptive text read by screen readers and search engines.
export const galleryImages = [
  {
    id: 1,
    thumb: "/gallery/thumbs/k001.webp",
    full: "/gallery/full/k001.webp",
    caption: "Administering laser therapy treatment",
    alt: "Krina Panchal administering low-level laser therapy to the temporomandibular joint at The TMD Physio Waterloo clinic",
  },
  {
    id: 2,
    thumb: "/gallery/thumbs/k002.webp",
    full: "/gallery/full/k002.webp",
    caption: "Performing targeted laser therapy",
    alt: "Close-up of Krina Panchal applying low-level laser therapy to a patient's jaw at The TMD Physio Waterloo clinic",
  },
  {
    id: 3,
    thumb: "/gallery/thumbs/k003.webp",
    full: "/gallery/full/k003.webp",
    caption: "Initial patient consultation session",
    alt: "Krina Panchal taking a patient history during an initial TMD consultation at The TMD Physio Waterloo clinic",
  },
  {
    id: 4,
    thumb: "/gallery/thumbs/k004.webp",
    full: "/gallery/full/k004.webp",
    caption: "Initial patient consultation session",
    alt: "Krina Panchal listening and making notes during a first-appointment consultation in the Waterloo clinic",
  },
  {
    id: 5,
    thumb: "/gallery/thumbs/k005.webp",
    full: "/gallery/full/k005.webp",
    caption: "Explaining cranial anatomy with a model",
    alt: "Krina Panchal explaining cranial and jaw anatomy to a patient using a skull model",
  },
  {
    id: 6,
    thumb: "/gallery/thumbs/k006.webp",
    full: "/gallery/full/k006.webp",
    caption: "Krina drawing on whiteboard",
    alt: "Krina Panchal drawing the trigeminal nerve pathways on a whiteboard to explain jaw, headache and ear symptoms",
  },
  {
    id: 7,
    thumb: "/gallery/thumbs/k007.webp",
    full: "/gallery/full/k007.webp",
    caption: "Displaying a jaw anatomical model",
    alt: "Krina Panchal holding an anatomical jaw model to show the temporomandibular joint disc and condyle",
  },
  {
    id: 8,
    thumb: "/gallery/thumbs/k008.webp",
    full: "/gallery/full/k008.webp",
    caption: "Krina holding skull model",
    alt: "Krina Panchal holding a skull model to show how the jaw joint sits in front of the ear",
  },
  {
    id: 9,
    thumb: "/gallery/thumbs/k009.webp",
    full: "/gallery/full/k009.webp",
    caption: "Krina explaining joint movement",
    alt: "Krina Panchal explaining temporomandibular joint movement to a patient with an anatomical model",
  },
  {
    id: 10,
    thumb: "/gallery/thumbs/k010.webp",
    full: "/gallery/full/k010.webp",
    caption: "Performing a patient examination",
    alt: "Krina Panchal performing a hands-on neck and jaw examination on a seated patient at The TMD Physio Waterloo clinic",
  },
  {
    id: 11,
    thumb: "/gallery/thumbs/k011.webp",
    full: "/gallery/full/k011.webp",
    caption: "Capturing posture with a device",
    alt: "Krina Panchal capturing a patient's head and neck posture with a handheld assessment device",
  },
  {
    id: 12,
    thumb: "/gallery/thumbs/k012.webp",
    full: "/gallery/full/k012.webp",
    caption: "Assessing jaw mobility",
    alt: "Krina Panchal measuring a patient's mouth opening with a jaw gauge during a TMD assessment",
  },
  {
    id: 13,
    thumb: "/gallery/thumbs/k013.webp",
    full: "/gallery/full/k013.webp",
    caption: "Measuring range of jaw opening",
    alt: "Krina Panchal measuring maximum jaw opening in millimetres during a TMD assessment",
  },
  {
    id: 14,
    thumb: "/gallery/thumbs/k014.webp",
    full: "/gallery/full/k014.webp",
    caption: "Assessing jaw range of motion",
    alt: "Krina Panchal checking jaw range of motion with a ruler at the patient's mouth, side view",
  },
  {
    id: 15,
    thumb: "/gallery/thumbs/k015.webp",
    full: "/gallery/full/k015.webp",
    caption: "Assessing jaw mobility",
    alt: "Krina Panchal listening to a patient's temporomandibular joint with a stethoscope for clicking and crepitus",
  },
  {
    id: 16,
    thumb: "/gallery/thumbs/k016.webp",
    full: "/gallery/full/k016.webp",
    caption: "Performing intricate jaw release therapy",
    alt: "Krina Panchal performing detailed intraoral release of the jaw muscles on a patient lying on the couch",
  },
  {
    id: 17,
    thumb: "/gallery/thumbs/k017.webp",
    full: "/gallery/full/k017.webp",
    caption: "Manual TMJ therapy session",
    alt: "Krina Panchal delivering manual therapy to the temporomandibular joint and masseter at The TMD Physio Waterloo clinic",
  },
  {
    id: 18,
    thumb: "/gallery/thumbs/k018.webp",
    full: "/gallery/full/k018.webp",
    caption: "Performing a TMJ assessment",
    alt: "Krina Panchal assessing TMJ tracking and clicking with her fingertips over a patient's jaw joints",
  },
  {
    id: 19,
    thumb: "/gallery/thumbs/k019.webp",
    full: "/gallery/full/k019.webp",
    caption: "Assessing jaw mobility",
    alt: "Krina Panchal performing an intraoral examination of the jaw muscles on a patient lying on the couch",
  },
  {
    id: 20,
    thumb: "/gallery/thumbs/k020.webp",
    full: "/gallery/full/k020.webp",
    caption: "Providing relief with facial massage",
    alt: "Krina Panchal giving a therapeutic facial and jaw massage to ease masseter tension",
  },
  {
    id: 21,
    thumb: "/gallery/thumbs/k021.webp",
    full: "/gallery/full/k021.webp",
    caption: "Providing gentle manual therapy",
    alt: "Krina Panchal applying gentle manual therapy to a patient's jaw and upper neck",
  },
  {
    id: 22,
    thumb: "/gallery/thumbs/k022.webp",
    full: "/gallery/full/k022.webp",
    caption: "Putting on laser safety glasses",
    alt: "Krina Panchal putting on protective glasses before a low-level laser therapy session",
  },
  {
    id: 23,
    thumb: "/gallery/thumbs/k023.webp",
    full: "/gallery/full/k023.webp",
    caption: "Performing laser TMJ therapy",
    alt: "Krina Panchal applying low-level laser therapy directly over a patient's temporomandibular joint",
  },
  {
    id: 24,
    thumb: "/gallery/thumbs/k024.webp",
    full: "/gallery/full/k024.webp",
    caption: "Performing laser therapy treatment",
    alt: "Krina Panchal wearing laser safety glasses while treating a patient's jaw with low-level laser therapy",
  },
  {
    id: 25,
    thumb: "/gallery/thumbs/k025.webp",
    full: "/gallery/full/k025.webp",
    caption: "Dry needling a patient's jaw",
    alt: "Krina Panchal inserting a dry-needling needle into a patient's masseter muscle for trigger-point release",
  },
  {
    id: 26,
    thumb: "/gallery/thumbs/k026.webp",
    full: "/gallery/full/k026.webp",
    caption: "Providing therapeutic neck massage",
    alt: "Krina Panchal giving a therapeutic neck and suboccipital massage for headache and jaw tension",
  },
  {
    id: 27,
    thumb: "/gallery/thumbs/k027.webp",
    full: "/gallery/full/k027.webp",
    caption: "Providing dry needling therapy",
    alt: "Krina Panchal performing dry needling of the jaw and neck muscles on a patient lying face up",
  },
  {
    id: 28,
    thumb: "/gallery/thumbs/k028.webp",
    full: "/gallery/full/k028.webp",
    caption: "Providing spinal therapy",
    alt: "Krina Panchal mobilising a patient's upper cervical spine to treat cervicogenic headache",
  },
  {
    id: 29,
    thumb: "/gallery/thumbs/k029.webp",
    full: "/gallery/full/k029.webp",
    caption: "Krina applying therapeutic tape",
    alt: "Krina Panchal applying myofascial tape to a patient's jaw and neck",
  },
  {
    id: 30,
    thumb: "/gallery/thumbs/k030.webp",
    full: "/gallery/full/k030.webp",
    caption: "Assessing jaw range of motion",
    alt: "Krina Panchal and a patient locating the temporomandibular joint together during a range-of-motion check",
  },
  {
    id: 31,
    thumb: "/gallery/thumbs/k031.webp",
    full: "/gallery/full/k031.webp",
    caption: "Assessing jaw mobility",
    alt: "Krina Panchal demonstrating a controlled jaw-opening exercise while the patient copies the movement",
  },
  {
    id: 32,
    thumb: "/gallery/thumbs/k032.webp",
    full: "/gallery/full/k032.webp",
    caption: "Performing jaw manipulation technique",
    alt: "Krina Panchal performing a gentle jaw mobilisation technique with the patient lying down",
  },
  {
    id: 33,
    thumb: "/gallery/thumbs/k033.webp",
    full: "/gallery/full/k033.webp",
    caption: "Demonstrating jaw anatomy with model",
    alt: "Close-up of a mandible (lower jaw) model held in Krina Panchal's hands to explain TMJ anatomy",
  },
  {
    id: 34,
    thumb: "/gallery/thumbs/k034.webp",
    full: "/gallery/full/k034.webp",
    caption: "Demonstrating with a jaw model",
    alt: "Krina Panchal demonstrating disc displacement with a hinged jaw model",
  },
  {
    id: 35,
    thumb: "/gallery/thumbs/k035.webp",
    full: "/gallery/full/k035.webp",
    caption: "Demonstrating jaw anatomy with model",
    alt: "Krina Panchal pointing to the condyle on a lower-jaw model to explain how the temporomandibular joint moves",
  },
  {
    id: 36,
    thumb: "/gallery/thumbs/k036.webp",
    full: "/gallery/full/k036.webp",
    caption: "Explaining mandibular anatomy",
    alt: "Krina Panchal explaining the anatomy of the mandible and jaw muscles to a patient",
  },
  {
    id: 37,
    thumb: "/gallery/thumbs/k037.webp",
    full: "/gallery/full/k037.webp",
    caption: "Explaining mandibular anatomy model",
    alt: "Krina Panchal using a mandible model to explain where jaw clicking comes from",
  },
  {
    id: 38,
    thumb: "/gallery/thumbs/k038.webp",
    full: "/gallery/full/k038.webp",
    caption: "Examining a cranial model",
    alt: "Krina Panchal examining a cranial model to show how the jaw, skull and neck connect",
  },
  {
    id: 39,
    thumb: "/gallery/thumbs/k039.webp",
    full: "/gallery/full/k039.webp",
    caption: "Displaying colored cranial bones",
    alt: "Krina Panchal holding a colour-coded skull model showing the individual cranial bones",
  },
  {
    id: 40,
    thumb: "/gallery/thumbs/k040.webp",
    full: "/gallery/full/k040.webp",
    caption: "Performing targeted facial release",
    alt: "Krina Panchal performing targeted myofascial release of the facial and jaw muscles",
  },
  {
    id: 41,
    thumb: "/gallery/thumbs/k041.webp",
    full: "/gallery/full/k041.webp",
    caption: "Performing facial acupuncture treatment",
    alt: "Close-up of dry needling with fine acupuncture needles in a patient's masseter and jaw muscles",
  },
  {
    id: 42,
    thumb: "/gallery/thumbs/k042.webp",
    full: "/gallery/full/k042.webp",
    caption: "Performing facial needling",
    alt: "Krina Panchal placing fine needles in a patient's facial muscles for pain relief",
  },
  {
    id: 43,
    thumb: "/gallery/thumbs/k043.webp",
    full: "/gallery/full/k043.webp",
    caption: "Explaining treatment plan to patient",
    alt: "Krina Panchal explaining a personalised TMD treatment plan to a patient at The TMD Physio Waterloo clinic",
  },
  {
    id: 44,
    thumb: "/gallery/thumbs/k044.webp",
    full: "/gallery/full/k044.webp",
    caption: "Krina holding skull anatomy model",
    alt: "Krina Panchal holding a skull anatomy model while explaining the temporomandibular joint",
  },
  {
    id: 45,
    thumb: "/gallery/thumbs/k045.webp",
    full: "/gallery/full/k045.webp",
    caption: "Sketching on a whiteboard",
    alt: "Krina Panchal sketching the jaw joint and surrounding muscles on a whiteboard for a patient",
  },
  {
    id: 46,
    thumb: "/gallery/thumbs/k046.webp",
    full: "/gallery/full/k046.webp",
    caption: "Explaining anatomy to a patient",
    alt: "Krina Panchal explaining jaw and neck anatomy to a patient during a consultation",
  },
  {
    id: 47,
    thumb: "/gallery/thumbs/k047.webp",
    full: "/gallery/full/k047.webp",
    caption: "Krina examining patient's jaw",
    alt: "Krina Panchal examining a patient's jaw joint and muscles with both hands",
  },
  {
    id: 48,
    thumb: "/gallery/thumbs/k048.webp",
    full: "/gallery/full/k048.webp",
    caption: "Assessing jaw mobility",
    alt: "Krina Panchal palpating the masseter and temporomandibular joint of a seated patient",
  },
  {
    id: 49,
    thumb: "/gallery/thumbs/k049.webp",
    full: "/gallery/full/k049.webp",
    caption: "Measuring mouth opening distance",
    alt: "Krina Panchal measuring a patient's mouth-opening distance with a jaw ruler",
  },
  {
    id: 50,
    thumb: "/gallery/thumbs/k050.webp",
    full: "/gallery/full/k050.webp",
    caption: "Assessing jaw joint function",
    alt: "Krina Panchal assessing jaw joint function as the patient opens and closes their mouth",
  },
  {
    id: 51,
    thumb: "/gallery/thumbs/k051.webp",
    full: "/gallery/full/k051.webp",
    caption: "Performing laser therapy treatment",
    alt: "Krina Panchal positioning the low-level laser device over a patient's jaw during photobiomodulation treatment",
  },
  {
    id: 52,
    thumb: "/gallery/thumbs/k052.webp",
    full: "/gallery/full/k052.webp",
    caption: "Performing targeted laser therapy",
    alt: "Krina Panchal in protective glasses delivering low-level laser therapy to a patient lying on the treatment couch",
  },
  {
    id: 53,
    thumb: "/gallery/thumbs/k053.webp",
    full: "/gallery/full/k053.webp",
    caption: "Performing acupuncture treatment",
    alt: "Krina Panchal performing acupuncture-style dry needling around the jaw and temple",
  },
  {
    id: 54,
    thumb: "/gallery/thumbs/k054.webp",
    full: "/gallery/full/k054.webp",
    caption: "Performing facial acupuncture treatment",
    alt: "Krina Panchal performing facial dry needling on a patient lying on the treatment couch at The TMD Physio Waterloo clinic",
  },
  {
    id: 55,
    thumb: "/gallery/thumbs/k055.webp",
    full: "/gallery/full/k055.webp",
    caption: "Guiding a jaw mobility exercise",
    alt: "Krina Panchal guiding a patient through a jaw mobility exercise in front of a mirror",
  },
  {
    id: 56,
    thumb: "/gallery/thumbs/k056.webp",
    full: "/gallery/full/k056.webp",
    caption: "Patient assessing jaw movement",
    alt: "Patient checking their own jaw movement under Krina Panchal's guidance at The TMD Physio Waterloo clinic",
  },
  {
    id: 57,
    thumb: "/gallery/thumbs/k057.webp",
    full: "/gallery/full/k057.webp",
    caption: "Assessing neck mobility",
    alt: "Krina Panchal assessing a patient's neck mobility as part of a combined jaw and neck examination",
  },
];
